import React from 'react'
import styled from 'styled-components'

import Content from './Content'
import Highlight from './Highlight'
import ArrowRight from './Icons/ArrowRight'

const Wrapper = styled.div`
  padding: 3rem 0 5rem 0;

  @media (min-width: 860px) {
    padding: 5rem 0 8rem 0;
  }
`

const Meta = styled.div`
  font-size: 26px;
  margin-bottom: 0.75rem;

  @media (max-width: 480px) {
    font-size: 22px;
  }
`

const Title = styled.h1`
  font-size: 104px;
  margin: 0;
  padding: 0;
  line-height: 1;
  font-weight: bold;

  @media (max-width: 860px) {
    font-size: 72px;
  }

  @media (max-width: 480px) {
    font-size: 52px;
  }
`

const Text = styled.p`
  font-size: 28px;
  line-height: 1.4;
  max-width: 920px;
  margin: 2.5rem 0 0 0;

  @media (max-width: 480px) {
    font-size: 23px;
  }
`

const Links = styled.div`
  display: grid;
  gap: 20px;
  margin-top: 3.5rem;

  @media (min-width: 720px) {
    grid-template-columns: 1fr 1fr;
    max-width: 920px;
  }
`

const LinkCard = styled.a`
  display: block;
  color: inherit;
  text-decoration: none;
  border: 3px solid #1d1d1b;
  border-radius: 16px;
  padding: 1.75rem 2rem;
  transition: background 0.2s ease;

  &:hover {
    background: #feef9e;
  }

  &:hover svg {
    transform: translateX(10px);
  }
`

const LinkLabel = styled.div`
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 0.35rem;
`

const LinkTitle = styled.div`
  font-size: 34px;
  font-weight: bold;
  line-height: 1;
  display: flex;
  align-items: center;

  svg {
    height: 24px;
    width: auto;
    margin-left: 12px;
    transition: transform 0.25s ease;
  }

  @media (max-width: 480px) {
    font-size: 30px;
  }
`

export const Handover = () => (
  <Wrapper>
    <Content>
      <Meta>Übergabe an die digicube AG</Meta>
      <Title>
        Studio A45 geht in <Highlight>neue Hände</Highlight>.
      </Title>
      <Text>
        Nach 8 Jahren haben wir das Web-Geschäft an die digicube AG aus Schaan
        übergeben und widmen uns ab jetzt ganz Rezendo. Seit dem 1. Juli 2026
        betreut digicube unsere Kundinnen und Kunden.
      </Text>
      <Links>
        <LinkCard href="https://digicube.li" title="Zur Website von digicube">
          <LinkLabel>Für unsere Kunden</LinkLabel>
          <LinkTitle>
            Zu digicube <ArrowRight />
          </LinkTitle>
        </LinkCard>
        <LinkCard href="https://www.rezendo.com" title="Zur Website von Rezendo">
          <LinkLabel>Das machen wir jetzt</LinkLabel>
          <LinkTitle>
            Zu Rezendo <ArrowRight />
          </LinkTitle>
        </LinkCard>
      </Links>
    </Content>
  </Wrapper>
)

export default Handover
